import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import PhotoboothBackground from './PhotoboothBackground'
import Pager from './Pager'

@inject("store")
@observer
export default class BackdropCategory extends React.Component {
  static propTypes = {
    backdropCategory: PropTypes.object.isRequired
  }

  state = {
    currentStartPage: 1,
    currentEndPage: 1
  }

  handlePageChange = (page) => {
    this.setState({ currentStartPage: page, currentEndPage: page })
  }

  handleLoadMore = () => {
    this.setState({ currentEndPage: this.state.currentEndPage + 1})
  }

  render() {
    const { backdropCategory, showPrice, showTitle, showBookNowButton, bookNowButtonText, textColor, fontFamily, buttonBackgroundColor, buttonForegroundColor, perPage, store } = this.props
    const { currentStartPage, currentEndPage } = this.state
    const { showCategoryHeaders } = store

    const allResults = store.backdropsForCategory(backdropCategory)
    const totalPages = Math.ceil(allResults.length / perPage)
    const activeResults = paginatedResults(allResults, currentStartPage, currentEndPage, perPage)

    return (
      <div className="cc-widget-category-container">
        { showCategoryHeaders &&
          <div style={{ fontFamily }} className="cc-widget-category-title" >{ backdropCategory.attributes.name }</div>
        }
        <div>
          <div className="cc-widget-backdrop-container">
            { activeResults.map(photoboothBackground =>
            <PhotoboothBackground
              key={photoboothBackground.id}
              photoboothBackground={photoboothBackground}
              showPrice={showPrice}
              showTitle={showTitle}
              showBookNowButton={showBookNowButton}
              bookNowButtonText={bookNowButtonText}
              textColor={textColor}
              fontFamily={fontFamily}
              buttonBackgroundColor={buttonBackgroundColor}
              buttonForegroundColor={buttonForegroundColor}
            />
            )}
          </div>

          <div className="cc-widget-pager-container">
            <Pager
              currentPage={currentEndPage}
              totalPages={totalPages}
              onChangePage={this.handlePageChange}
              onLoadMore={this.handleLoadMore}
              fontFamily={fontFamily}
            />
          </div>
          { !activeResults.length && <p className="text-center">No backdrops matched your search</p> }
        </div>
      </div>
    )
  }
}

function paginatedResults(results, currentStartPage, currentEndPage, perPage) {
  return results.slice((currentStartPage - 1) * perPage, currentEndPage * perPage)
}
